import React, { createContext, useContext, useReducer } from 'react';
import Snackbar from "../shared/Snackbar";

const FeedbackContext = createContext(null);

const FeedbackDispatchContext = createContext(null);

export function FeedbackProvider({children}) {

    const [feedback, dispatch] = useReducer(
        feedbackReducer,
        initialFeedback
    );

    return (
        <FeedbackContext.Provider value={feedback}>
            <FeedbackDispatchContext.Provider value={dispatch}>
                <Snackbar />
                {children}
            </FeedbackDispatchContext.Provider>
        </FeedbackContext.Provider>
    );
}

function feedbackReducer(feedback, action) {

    switch (action.type) {
        case FeedbackReducerActionType.SHOW_FEEDBACK:
            return action.data;
        case FeedbackReducerActionType.CLOSE_FEEDBACK:
            return {...feedback, open: false};
    }

}

export const FeedbackReducerActionType = {
    SHOW_FEEDBACK: 0,
    CLOSE_FEEDBACK: 1
}

export function useFeedback() {
    return useContext(FeedbackContext);
}

export function useFeedbackDispatch() {
    return useContext(FeedbackDispatchContext);
}

const initialFeedback = {
    severity : "info",
    message : "",
    open : false,
    time : 0,
    closeType : null
}
